/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { showSuccess } from "~/components/Toast";
import { useCustomer } from "~/context/User/Customer";
import {
  generateActionConfirmText,
  generateActionSuccessText,
  useAxios,
} from "~/tools";
import { AssignedProductItem } from "./types";

type UnassignProductProps = {
  product: AssignedProductItem;
  refetch: () => void;
};

function UnassignProduct({ product, refetch }: UnassignProductProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { showError } = useShowError();
  const { Axios } = useAxios();
  const { customer } = useCustomer();

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        type="button"
        css={{ marginRight: "1rem" }}
        size="sm"
        severity="low"
        icon="brokenLink"
      >
        Unassign
      </Button>
      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={async () => {
          try {
            await Axios().delete(
              `/customers/${customer.id}/products/${product.id}`
            );
            setIsOpen(true);
            refetch();
            showSuccess(
              generateActionSuccessText(`The ${product?.name} product`)()(
                "detached"
              )()
            );
          } catch (e) {
            showError(e.response);
          }
          setIsOpen(false);
        }}
        actionLabel="Unassign"
        contentLabel="Unassign Product"
      >
        {generateActionConfirmText(`${product?.name} product`)("unassign")()}
      </ModalConfirm>
    </>
  );
}

export { UnassignProduct };
